/** @format */

/**
 * body: backgorund
 * textSecondary: blue pink
 * textPrimary: black white
 */

export const LightTheme = {
    body: "#FFFFFF", // background color
    bodySecondary: "#222222", // background - black
    textPrimary: "#222222", // hero color - black
    textSecondary: "#05AA5D", // color - green
    backgLight: "rgba(6, 195, 107, 0.3)",
    display: 'none',
    displayrev: 'block'
}
export const DarkTheme = {
    body: "#141925", // background color
    bodySecondary: "#DDDDDD", // background - grey
    textPrimary: "#DDDDDD", // hero color - light
    textSecondary: "#05AA5D", // color - green
    backgLight: "rgba(6, 195, 107, 0.2)",
    display: 'block',
    displayrev: 'none'
};